import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Table, Row, Col, Button, Icon } from 'antd'

import moment from 'moment'

import Details from './Details'
import UsageMode from './UsageMode'

@inject((store: any) => {
    const { popupStore, collectionsStore, recordsStore } = store

    return { popupStore, collectionsStore, recordsStore }
})
@observer
class List extends Component<any> {
    handleRecordsPopup = id => {
        const { popupStore, recordsStore } = this.props
        recordsStore.getRecords(id)
        popupStore.togglePopup('records')
    }
    handleEditCollectionPopup = id => {
        const { popupStore, collectionsStore } = this.props
        collectionsStore.getCollection(id)
        popupStore.togglePopup('editCollection')
    }
    handleChangePage = page => {
        const { collectionsStore } = this.props
        collectionsStore.changePage(page)
        collectionsStore.getCollections(page)
    }
    render() {
        const {
            collectionsStore: { list, paging, loading, filters },
            udpateCollections
        } = this.props
        const columns = [
            {
                title: '',
                key: 'edit',
                width: 50,
                align: 'right',
                render: (_, record) => (
                    <Button onClick={() => this.handleEditCollectionPopup(record.id)}>
                        <Icon type="edit" />
                    </Button>
                )
            },
            {
                title: 'מזהה',
                key: 'id',
                width: 50,
                align: 'right',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'פרטי הזכות',
                key: 'name',
                width: 600,
                align: 'right',
                render: (_, record) => <Details {...record} />
            },
            {
                title: 'קטגוריות',
                key: 'categories',
                align: 'right',
                width: 300,
                render: (_, record) => (
                    <span>
                        {record.categories && record.categories.length > 0
                            ? record.categories.map((category, index) => (
                                  <span key={index}>
                                      {index !== 0 ? ', ' : ''}
                                      <span
                                          style={{
                                              fontWeight:
                                                  filters.category && filters.category === category.category_id
                                                      ? 'bold'
                                                      : 'normal'
                                          }}
                                      >
                                          {category.name}
                                      </span>
                                  </span>
                              ))
                            : '--'}
                    </span>
                )
            },
            {
                title: 'סוג',
                key: 'type_name',
                align: 'right',
                width: 300,
                render: (_, record) => <span>{record.type_name ? record.type_name : '--'}</span>
            },
            {
                title: 'תחומי שירות',
                key: 'servicefields',
                align: 'right',
                width: 300,
                render: (_, record) => (
                    <span>
                        {record.servicefields && record.servicefields.length > 0
                            ? record.servicefields.map((service_field, index) => (
                                  <span key={index}>
                                      {index !== 0 ? ', ' : ''}
                                      <span
                                          style={{
                                              fontWeight:
                                                  filters.service_field &&
                                                  filters.service_field === service_field.servicefield_id
                                                      ? 'bold'
                                                      : 'normal'
                                          }}
                                      >
                                          {service_field.name}
                                      </span>
                                  </span>
                              ))
                            : '--'}
                    </span>
                )
            },
            {
                title: 'אופן שימוש',
                key: 'usageMode',
                align: 'right',
                width: 300,
                render: (_, record) => (
                    <UsageMode
                        usageMode={...record.usageMode.map(um => um.usagemode_id)}
                        collectionId={record.id}
                        title={...record.usageMode.map(um => um.name).join(', ')}
                        udpateCollections={udpateCollections}
                    />
                )
            },
            {
                title: '',
                key: 'edit_terms',
                width: 200,
                align: 'right',
                render: (_, record) => (
                    <Fragment>
                        <a
                            style={{ textDecoration: 'underline', color: 'black' }}
                            href={`/collection-terms/${record.id}`}
                            target="_blank"
                        >
                            <Icon type="form" style={{ marginLeft: '0.2rem' }} />
                            עריכת תנאים
                        </a>
                    </Fragment>
                )
            },
            {
                title: '',
                key: 'source_id',
                align: 'right',
                width: 150,
                render: (_, record) => (
                    <Fragment>
                        {record.source_id !== 'LOCAL' ? (
                            <a
                                style={{ textDecoration: 'underline', color: 'black' }}
                                target="_blank"
                                href={`http://call.health.gov.il/infocenter/index?page=content&id=${record.source_id}`}
                            >
                                <Icon type="link" style={{ marginLeft: '0.2rem' }} />
                                מקור
                            </a>
                        ) : (
                            'נוצר במערכת'
                        )}
                    </Fragment>
                )
            },
            {
                title: 'עודכן ע"י',
                key: 'updated_by',
                align: 'right',
                width: 170,
                render: (_, record) => <span>{record.updated_by ? record.updated_by : '--'}</span>
            },
            {
                title: 'עדכון אחרון',
                key: 'updated_at',
                align: 'right',
                width: 170,
                render: (_, record) => (
                    <span>{record.updated_at ? moment(record.updated_at).format('HH:mm DD/MM/YYYY') : '--'}</span>
                )
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            columns={columns}
                            loading={loading}
                            dataSource={list}
                            pagination={{
                                total: paging.total,
                                pageSize: paging.perPage,
                                current: paging.page,
                                onChange: value => this.handleChangePage(value) //changePage(value)
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRouter(List)
